import { connect } from 'react-redux';

import SidebarContent from './SidebarContent';

const mapStateToProps = (state) => ({
  locationList: state.Location.locationList,
  placeDetail: state.Place.placeDetail,

  myPermission: state.Administrator.myPermission,
});

export default connect(mapStateToProps)(SidebarContent);
